export const RainCloudIllustration = () => (
    <svg fill='none' height='70' viewBox='0 0 102 70' width='102' xmlns='http://www.w3.org/2000/svg'>
        <g filter='url(#filter0_din_5068_55395)'>
            <path
                d='M59.4727 6C69.4315 6 77.5048 14.0734 77.5049 24.0322C77.5049 25.6306 77.2966 27.1806 76.9062 28.6562H81.2041C86.8218 28.6564 91.376 33.2104 91.376 38.8281C91.3759 44.4458 86.8218 48.9999 81.2041 49H20.1719C14.5541 48.9999 10.0001 44.4459 10 38.8281C10 33.2103 14.5541 28.6563 20.1719 28.6562H23.0234C22.9731 28.2007 22.9463 27.7375 22.9463 27.2686C22.9465 20.3742 28.5353 14.7853 35.4297 14.7852C38.1813 14.7852 40.7237 15.6774 42.7871 17.1855C45.4831 10.6224 51.9377 6.00005 59.4727 6Z'
                fill='#525DCF'
            />
        </g>
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='43.688' y='52' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='47.688' y='52' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='51.688' y='52' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='55.688' y='52' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='43.688' y='57' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='47.688' y='57' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='51.688' y='57' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='55.688' y='57' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='43.688' y='62' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='47.688' y='62' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='51.688' y='62' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='55.688' y='62' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='47.688' y='67' />
        <rect fill='#CDE1FF' height='3' rx='1' width='2' x='51.688' y='67' />
        <defs>
            <filter
                colorInterpolationFilters='sRGB'
                filterUnits='userSpaceOnUse'
                height='63'
                id='filter0_din_5068_55395'
                width='101.376'
                x='0'
                y='0'
            >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix in='SourceAlpha' result='hardAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
                <feOffset dy='4' />
                <feGaussianBlur stdDeviation='5' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
                <feBlend in2='BackgroundImageFix' mode='normal' result='effect1_dropShadow_5068_55395' />
                <feBlend in='SourceGraphic' in2='BackgroundImageFix' mode='normal' result='shape' />
                <feColorMatrix in='SourceAlpha' result='hardAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
                <feOffset dy='4' />
                <feGaussianBlur stdDeviation='2' />
                <feComposite in2='hardAlpha' k2='-1' k3='1' operator='arithmetic' />
                <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
                <feBlend in2='shape' mode='normal' result='effect2_innerShadow_5068_55395' />
                <feTurbulence
                    baseFrequency='3.7037036418914795 3.7037036418914795'
                    numOctaves='3'
                    result='noise'
                    seed='1162'
                    stitchTiles='stitch'
                    type='fractalNoise'
                />
                <feColorMatrix in='noise' result='alphaNoise' type='luminanceToAlpha' />
                <feComponentTransfer in='alphaNoise' result='coloredNoise1'>
                    <feFuncA
                        tableValues='1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 '
                        type='discrete'
                    />
                </feComponentTransfer>
                <feComposite in='coloredNoise1' in2='effect2_innerShadow_5068_55395' operator='in' result='noise1Clipped' />
                <feFlood floodColor='rgba(255, 255, 255, 0.1)' result='color1Flood' />
                <feComposite in='color1Flood' in2='noise1Clipped' operator='in' result='color1' />
                <feMerge result='effect3_noise_5068_55395'>
                    <feMergeNode in='effect2_innerShadow_5068_55395' />
                    <feMergeNode in='color1' />
                </feMerge>
                <feBlend
                    in='effect3_noise_5068_55395'
                    in2='effect1_dropShadow_5068_55395'
                    mode='normal'
                    result='effect3_noise_5068_55395'
                />
            </filter>
        </defs>
    </svg>
);
